import type { ReactNode, Ref, SelectHTMLAttributes } from 'react';
import type { PrimitiveProps } from './Button';
import { cx } from './cx';
import s from './Select.module.css';

export interface SelectProps extends PrimitiveProps<SelectHTMLAttributes<HTMLSelectElement>> {
  /** Draws the critical border. Field sets this from its own error. */
  invalid?: boolean;
  children?: ReactNode;
  ref?: Ref<HTMLSelectElement>;
}

/**
 * The element stays native. A listbox rebuilt out of divs is the one control a phone gets
 * worse: what a <select> buys is the OS picker, and no ARIA pattern buys it back.
 */
export function Select({ invalid = false, children, ...rest }: SelectProps) {
  return (
    <span className={s.wrap}>
      <select
        {...rest}
        {...(invalid ? { 'aria-invalid': true } : {})}
        className={cx(s.select, invalid && s.invalid)}
      >
        {children}
      </select>
    </span>
  );
}

export default Select;
